import * as React from "react";
import { OpenChatIcon } from "@/views/open-chat/components/openChatIcon";
import { useGetConversationsQuery, useUpdateConversationMutation } from "@/api/open-chat";
import TopBarProgress from "react-topbar-progress-indicator";
import { OpenChatMessage } from "@/types/open-chat";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

interface Props {
  conversationId: string;
  messages: OpenChatMessage[];
}

export const OpenChatHeader: React.FC<Props> = ({ conversationId, messages }) => {
  const [updateConversation, { isLoading }] = useUpdateConversationMutation();

  const { data: conversations, isSuccess } = useGetConversationsQuery();
  const conversation = conversations?.find(c => c.id === conversationId);
  const [name, setName] = React.useState<string>("Open Chat by Pathfinder");

  const updateConversationName = React.useCallback(
    async (newName: string) => {
      const response = await updateConversation({ id: conversationId, data: { name: newName.trim() } }).unwrap();
      setName(response.name);
    },
    [updateConversation, conversationId],
  );

  React.useEffect(() => {
    if (isSuccess && conversation?.name) {
      setName(conversation?.name);
    }
  }, [isSuccess, conversation]);

  const generateAutoTitle = messages.filter(row => row.type === "ai" && row.completed).length === 1;

  React.useEffect(() => {
    if (generateAutoTitle && conversation && !conversation.name) {
      updateConversationName("");
    }
  }, [generateAutoTitle, conversation, updateConversationName]);

  return (
    <div className="border-b border-gray-200 bg-white p-4">
      <div className="flex w-full flex-wrap items-center justify-start space-x-2 lg:flex-nowrap">
        {isLoading && <TopBarProgress />}
        <OpenChatIcon />
        {isSuccess && (
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            onBlur={() => updateConversationName(name)}
            className="w-full border-none bg-transparent py-0 focus:outline-none"
          />
        )}
        <Link to="/open-chat" className="text-right">
          <Button className="m-0" size={"sm"}>
            New chat
          </Button>
        </Link>
      </div>
    </div>
  );
};
